// Scroll-to-hit.
//
// When a visitor arrives from the search results (URL carries ?highlight=…),
// Relevanssi highlights the matched terms in the document. This jumps to the
// first highlighted element so the user lands right on the relevant passage.

function scrollToHighlight() {
  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) {
    return;
  }
  if (!params.has('highlight')) {
    return;
  }

  // Relevanssi wraps matches in <mark>, .relevanssi-query-term, or .hilite.
  var target = document.querySelector('mark, .relevanssi-query-term, .hilite');
  if (!target) {
    return;
  }

  var OFFSET = 110; // room for the fixed navbar
  var top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;

  window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
}

if (document.readyState !== 'loading') {
  scrollToHighlight();
} else {
  document.addEventListener('DOMContentLoaded', scrollToHighlight);
}

module.exports = {};
